import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M17.176 3.844h2.76l-6.03 6.91L21 20.156h-5.554l-4.35-5.702-4.979 5.702H3.355l6.45-7.39L3 3.843h5.695l3.933 5.212 4.548-5.212ZM16.207 18.5h1.53L7.864 5.413h-1.64L16.206 18.5Z"
    />
  </svg>
`;
